import * as Yup from 'yup';
import axios from 'axios';
import md5 from "md5";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { Stack, TextField, IconButton, InputAdornment, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { getToken } from '../../../config/services/token'
import settings from '../../../config/settings';
import { userActivityLog } from '../../../config/services/activityLog';
// import { getRoleDetailsByName } from '../../../config/services/role';
import { EncryptData } from '../../../utils/encryptDecrypt';
import CryptoJS from "crypto-js";
var axiosInstance = axios.create()
// ----------------------------------------------------------------------

export default function LoginForm() {
  let token = localStorage.getItem('accessToken')
  const websiteKey = 'D21B2DBA59F52167BEBFF2484DAFB'
  const websiteMsaSalt = 'CoLo&Mi!2021'
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  let fetchToken = async (params) => {
    let tokenObj = await getToken(params)
    return tokenObj?.data
  }
  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('Username is required'),
    password: Yup.string().required('Password is required')
  });

  // if (token) {
  //   navigate('/dashboard', { replace: true });
  // }

  const ClearLocalStorage = () => {
    localStorage.clear();
  }
  useEffect(() => ClearLocalStorage(), []);

  const getChecksum = (action, username, password) => {
    let checksum = md5(
      action +
      ":" +
      websiteKey +
      ":" +
      username +
      ":" +
      password +
      ":" +
      websiteMsaSalt
    );
    return checksum
  }

  const getChecksumNew = (str,encType) => {
    switch(encType){
      case 1:
        return CryptoJS.SHA512(str).toString()
      default:
        return CryptoJS.MD5(str).toString()
    }
  }

  const formik = useFormik({
    initialValues: { username: '', password: '' },
    validationSchema: LoginSchema,

    onSubmit: (values, actions) => {
      let { username, password } = values
      let checksumStr = `cognito_login:${websiteKey}:${username}:${password}:${websiteMsaSalt}`
      let encType = 1
      let data = {
        action: "cognito_login",
        apikey: websiteKey,
        checksum: getChecksumNew(checksumStr,encType),
        enc_type:encType,
        login_details: {
          username: username,
          password: password,
          app_name: 'Student_App',
          acess_id: "",
          // access_type:"",
          app_version: "",
          gcm_key: "",
          email_address: "",
          latitude: "",
          longitude: "",
          operating_system_version: 10,
          source: "website"
        },
        refresh_token: ""
      };
      let config = {}
      let url = `${settings.WEBSITE_URL}cognito-login-service/auth/login?v=2`
      axiosInstance.post(url, data, config).then(
        (res) => {
          //console.log('Login', res)
          if (res.data.status_code == 1) {
            let token = res.data.access_token
            let id = res.data.uuid
            localStorage.setItem('emUserId', EncryptData(res.data.em_user_id))
            localStorage.setItem('uuid', EncryptData(res.data.uuid))
            localStorage.setItem('s_uuid', EncryptData(res.data.uuid))
            localStorage.setItem('s_uuids', EncryptData(JSON.stringify([res.data.uuid])))
            localStorage.setItem('t_uuid', EncryptData(JSON.stringify([res.data.uuid])))
            let url = `${settings.WEBSITE_URL}cognito-login-service/auth/getUserInfo`
            let data = {
              action: "cognito_get_user_info",
              apikey: "D21B2DBA59F52167BEBFF2484DAFB",
              checksum: md5("cognito_get_user_info:" + websiteKey + ":" + username + ":" + websiteMsaSalt),
              username: username
            }
            let config = {
              headers: {
                'Authorization': 'Bearer ' + token,
                'token': token
              }
            }
            axiosInstance.post(url, data, config).then(
              (resp) => {
                if (resp.data.status == 200) {
                  let resData = resp.data.data
                  localStorage.setItem('username', EncryptData(resData.username))
                  localStorage.setItem('name', EncryptData(resData.name))
                  localStorage.setItem('email', EncryptData(resData.email))
                  localStorage.setItem('role', EncryptData(resData.role))
                  let params = {
                    uuid: id,
                    role: resData.role
                  }
                  if(resData?.crm_role){
                    localStorage.setItem('role', EncryptData(resData.crm_profile))                    
                    localStorage.setItem('crmRoles',EncryptData(JSON.stringify(resData?.crm_role.split(','))))
                    params.uuid = resData?.crm_role.split(',')[0]
                    params.role = resData.crm_profile
                    localStorage.setItem('uuid', EncryptData(params.uuid))
                    localStorage.setItem('s_uuid', EncryptData(params.uuid))
                    localStorage.setItem('s_uuids', EncryptData(JSON.stringify([params.uuid])))
                    localStorage.setItem('t_uuid', EncryptData(JSON.stringify([params.uuid])))
                  }
                  
                  fetchToken(params)
                    .then(userDetail => {
                      actions.setSubmitting(false);
                      let trackingEvent = {
                        em_guid: id,
                        uuid: id,
                        landing_page: '/dashboard',
                        action: "login",
                        date_time: new Date().toISOString(),
                        platform: "Report-Engine",
                        envirnment: settings?.env,
                        app_version: settings?.version,
                        browser: navigator?.userAgent,
                        os_details: navigator?.platform,
                        event_type: "Login",
                        eventStep: "login",
                        click_type: "Login",
                        value: JSON.stringify({ website: resp.data, repoting_tool: userDetail }),
                      }
                      localStorage.setItem('accessToken', userDetail.token)
                      axios.defaults.headers.common['accessToken'] = userDetail.token;
                      if (userDetail.cubeToken) {
                        localStorage.setItem('cubeToken', userDetail.cubeToken)
                      }
                      if (userDetail.menusAllowed) {
                        localStorage.setItem('menusAllowed', EncryptData(JSON.stringify(userDetail.menusAllowed)))
                      } else {
                        localStorage.removeItem('menusAllowed')
                      }
                      userActivityLog(trackingEvent)
                      const beforeLoginUrl = sessionStorage.getItem('beforeLogin');
                      sessionStorage.removeItem('beforeLogin');
                      //console.log('beforeLoginUrl', beforeLoginUrl)
                      //navigate(beforeLoginUrl ?? redirectTo)
                      navigate(beforeLoginUrl ?? '/dashboard')
                    })
                }
                else {
                  localStorage.clear()
                  actions.setSubmitting(false);
                }
              }
            ).catch(
              (err) => {
                localStorage.clear()
                actions.setSubmitting(false);
              }
            )
          } else {
            localStorage.clear()
            actions.setFieldError(password, res.data.message)
            actions.setSubmitting(false);
          }
        }
      ).catch(
        (e) => {
          console.log(e)
          localStorage.clear()
          actions.setSubmitting(false);
        }
      )
    }
  });

  const { errors, touched, values, status, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            type="text"
            label="Username"
            {...getFieldProps('username')}
            error={Boolean(touched.username && errors.username)}
            helperText={touched.username && errors.username}
          />
          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />
        </Stack>

        <Stack alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <LoadingButton mt={2} fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}> Login</LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
